import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import format from 'date-fns/format'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  TbBell,
  TbBellFilled,
  TbMailFilled,
  TbMessageFilled,
} from 'react-icons/tb'
import { useHistory } from 'react-router-dom'

import { NotificationsProps } from '../../../../interfaces/notifications'
import {
  getAllNotifications,
  requestPostMarkedAllNotificationAsSeen,
} from '../../../../services/notifications'
import { extractDateFormat } from '../../../../utils/dateFormat'
import getCookie from '../../../../utils/getCookies'
import { DialogNotify } from '../DialogNotify'
import { useStyles } from './styles'

interface DataNotificationsUnique {
  id: string
  titulo: string
  texto: string
  lido: boolean
  tipo: string
  created_at: string
}

export function Notification(): JSX.Element {
  const classes = useStyles()
  const history = useHistory()
  const token: string | null = getCookie('gov_access_token_sso')

  const [anchorElNotify, setAnchorElNotify] =
    React.useState<HTMLButtonElement | null>(null)
  const [notifications, setNotifications] = useState<NotificationsProps>()
  const [loadingNotificationsMarkAll, setLoadingNotificationsMarkAll] =
    useState(false)
  const [loading, setLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [dataNotificationsById, setDataNotificationsById] =
    useState<DataNotificationsUnique>()
  const [page] = useState<number>(1)

  const notificationHasData =
    notifications && notifications?.results?.length > 0
  const notificationHasNotData = notifications?.results?.length < 1

  const handleClosePoperNotifications = () => {
    setAnchorElNotify(null)
  }

  const onMarkAllNotificationAsSee = async () => {
    try {
      setLoadingNotificationsMarkAll(true)
      const data = await requestPostMarkedAllNotificationAsSeen(token)

      if (data?.status === 200) {
        handleClosePoperNotifications()
        setTimeout(() => {
          history.go(0)
        }, 2000)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingNotificationsMarkAll(false)
    }
  }

  function openModalNotify(id: string) {
    setModalOpen(true)
    const filterNotifyById = notifications?.results.filter(
      (item) => item.id === id,
    )[0]
    setDataNotificationsById(filterNotifyById)
    return
  }

  const handleClickPoperNotifications = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorElNotify(event.currentTarget)
  }

  const modifyListNotificationWithSeenWhenClickButton = useCallback(
    (id: string) => {
      const modifyNotification = notifications.results.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            lido: true,
          }
        }
        return {
          ...item,
        }
      })
      const notifyDifferentOfSeen = modifyNotification.filter(
        (item) => item.lido !== true,
      )
      setNotifications({ ...notifications, results: notifyDifferentOfSeen })
    },
    [notifications],
  )

  const unreadNotifications = useMemo(() => {
    if (notifications?.results?.length > 0) {
      return notifications?.results?.filter((notify) => !notify.lido).length > 0
    }
  }, [notifications])

  function closeModalNotify() {
    setModalOpen(false)
    return
  }

  useEffect(() => {
    const listNofications = async () => {
      try {
        setLoading(true)
        const { data } = await getAllNotifications({ token, page })
        const notifyDifferentOfSeen = data.results.filter(
          (item) => item.lido !== true,
        )
        setNotifications({ ...data, results: notifyDifferentOfSeen })
      } catch (error) {
      } finally {
        setLoading(false)
      }
    }
    listNofications()
  }, [page, token])

  return (
    <>
      {modalOpen && (
        <DialogNotify
          data={dataNotificationsById}
          onCloseModal={closeModalNotify}
        />
      )}

      <Button
        onClick={(e): void => handleClickPoperNotifications(e)}
        className={classes.buttonNotification}
      >
        <Box
          className={
            unreadNotifications ? classes.indicatorNotificationNotViewed : null
          }
        />
        <TbBell size={25} />
      </Button>

      <Popover
        open={Boolean(anchorElNotify)}
        anchorEl={anchorElNotify}
        onClose={handleClosePoperNotifications}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box className={classes.containerNotification}>
          <Box className={classes.contentNotificationTitle}>
            <Typography className={classes.notificationText}>
              Notificações
            </Typography>
            {notificationHasData && (
              <Button
                disabled={loadingNotificationsMarkAll}
                onClick={onMarkAllNotificationAsSee}
              >
                {loadingNotificationsMarkAll ? (
                  <CircularProgress size={20} />
                ) : (
                  <Typography className={classes.markAllNotificationText}>
                    Marcar todas como lidas
                  </Typography>
                )}
              </Button>
            )}
          </Box>
          <Box className={classes.gridMain}>
            {!notificationHasData && notificationHasNotData && (
              <Typography className={classes.textAlert}>
                Nenhum resultado foi encontrado!
              </Typography>
            )}
            {loading ? (
              <CircularProgress className={classes.iconProgress} />
            ) : (
              <>
                {notificationHasData &&
                  notifications.results.map((item) => {
                    return (
                      <Button
                        onClick={() => {
                          handleClosePoperNotifications()
                          openModalNotify(item.id)
                          modifyListNotificationWithSeenWhenClickButton(item.id)
                        }}
                        disableRipple
                        key={item.id}
                        className={classes.cardNotification}
                      >
                        <Box className={classes.itemMessageNotification}>
                          <Box
                            className={`${classes.boxIconMessageNotification} boxIconMessageNotification`}
                          >
                            {item.tipo === 'EMAIL' && (
                              <TbMailFilled
                                size={24}
                                className={classes.iconNotify}
                              />
                            )}
                            {item.tipo === 'SMS' && (
                              <TbMessageFilled
                                size={24}
                                className={classes.iconNotify}
                              />
                            )}
                            {item.tipo === 'PUSH' && (
                              <TbBellFilled
                                size={24}
                                className={classes.iconNotify}
                              />
                            )}
                          </Box>
                          <Box className={classes.boxInformationNotification}>
                            <Typography
                              className={`${classes.titleMainCard} titleMainCard`}
                            >
                              {item.titulo}
                            </Typography>
                            <Typography
                              className={`${classes.subTitleMainCard} subTitleMainCard`}
                            >
                              {item?.created_at
                                ? `${extractDateFormat(
                                    item?.created_at,
                                  )} - ${format(
                                    new Date(item?.created_at),
                                    'kk:mm',
                                  )}h`
                                : '03/09/2023 - 10:13h'}
                            </Typography>
                          </Box>
                        </Box>
                        <Box className={classes.asideLeftIcon}>
                          <Box
                            className={
                              item.lido
                                ? classes.indicatorNotificationViewedIcon
                                : classes.indicatorNotificationNotViewedIcon
                            }
                          />
                        </Box>
                      </Button>
                    )
                  })}
              </>
            )}
          </Box>
          {notifications && (
            <Button
              title="Visualizar notificações"
              onClick={() => {
                handleClosePoperNotifications()
                history.push('/workspace/notificacoes')
              }}
              disableRipple
              className={classes.footerNotify}
            >
              <Typography className={classes.footerTitleNotify}>
                Ver todas
              </Typography>
            </Button>
          )}
        </Box>
      </Popover>
    </>
  )
}
